import { unparse } from 'papaparse';

interface DataItem {
  cluster: string;
  keywords: string[];
  main_url: string;
  total_search_volume: number;
}

interface IntentClusters {
  topic: string;
  clusters: string[];
}

export const convertJsonToCsv = (jsonData: Record<string, any[]>): string => {
  if (!jsonData || typeof jsonData !== 'object') {
    console.warn("Invalid JSON object");
    return '';
  }

  const keys = Object.keys(jsonData);
  const maxLength = Math.max(...keys.map(key => jsonData[key]?.length || 0));

  const rows: Record<string, any>[] = [];

  for (let i = 0; i < maxLength; i++) {
    const row: Record<string, any> = {};
    keys.forEach(key => {
      row[key] = jsonData[key]?.[i] ?? '';
    });
    rows.push(row);
  }

  return unparse(rows);
};



export const exportJsonToCsv = (jsonData: DataItem[]) => {
  if (!Array.isArray(jsonData)) {
    console.warn("Invalid JSON array");
    return;
  }

  const rows: Record<string, any>[] = [];

  jsonData.forEach(item => {
    item.keywords.forEach((keyword, index) => {
      rows.push({
        cluster: index === 0 ? item.cluster : '',
        keywords: keyword,
        main_url: index === 0 ? item.main_url : '',
        total_search_volume: index === 0 ? item.total_search_volume : '',
      });
    });
  });

  return unparse(rows);
 
};

export const exportJsonToCsvBlogsAndPages = (jsonData: DataItem[]) => {
  if (!Array.isArray(jsonData)) {
    console.warn("Invalid JSON array");
    return;
  }

  const columns = [
    "classification",
    "keyword",
    "page_type",
    "parent_kw",
    "search_intent",
    "search_volume",
    "review_comparison",
    "business_relevance_score",
    "business_relevance_level",
  ];

  // Create a new array with only the required columns
  const processedData = jsonData.map((item: any) => {
    const row: Record<string, any> = {};
    columns.forEach((col: any) => {
      row[col] = item[col] ?? "";
    });
    return row;
  });

  return unparse(processedData);
 
};

export const exportFlattenedChannelDataToCsv = (jsonData: any[]) => {
  if (!Array.isArray(jsonData)) {
    console.warn("Invalid JSON array");
    return;
  }

  const columns = [
    "channelName",
    "channelRelevance",
    "campaignName",
    "campaignRelevance",
    "cluster",
    "contentType",
    "title",
    "description",
    "clusterRelevance",
    "relatedKeywords",
  ];

  const processedData = jsonData.map((item) => {
    const row: Record<string, any> = {};
    columns.forEach((col) => {
      row[col] = item[col] ?? "";
    });
    return row;
  });

  return unparse(processedData);
};
export const exportJsonToCsvForFifthStep = (jsonData: IntentClusters[]) => {
  if (!Array.isArray(jsonData)) {
    console.warn("Invalid JSON array");
    return;
  }

  const rows: Record<string, any>[] = [];

  jsonData.forEach(item => {
    item.clusters.forEach((cluster, index) => {
      rows.push({
        intentcluster: index === 0 ? item.topic : '',
        clusters: cluster
      });
    });
  });

  return unparse(rows);
 
};
